<template>
  <Select
    v-model="jobStatusId"
    :options="jobStatuses"
    :name="fieldName"
    no-label
    :full-width="false"
    data-cy="job-status-select"
    placeholder="Unknown"
    :allow-empty="false"
  ></Select>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { EventBus } from "@/lib/event_bus.js";

export default {
  props: {
    job: {
      type: Object,
      required: true
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      fieldName: "Job Status",
      selectedStatusId: this.job.status?.id
    };
  },
  computed: {
    ...mapState({
      jobStatuses({ jobStatuses }) {
        return jobStatuses.map((js) => ({
          ...js,
          label: js.name,
          value: js.id
        }));
      }
    }),
    jobStatusId: {
      get() {
        return this.selectedStatusId;
      },
      set(val) {
        this.selectedStatusId = val;
        this.$emit("update:modelValue", val);
      }
    }
  },
  watch: {
    selectedStatusId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.updateJobStatus(newVal);
      }
    }
  },
  mounted() {
    if (!this.jobStatuses.length) {
      this.fetchJobStatuses();
    }
  },
  methods: {
    ...mapActions(["fetchJobStatuses", "updateJob"]),
    updateJobStatus(statusId) {
      this.updateJob({
        jobId: this.job.id,
        job_status_id: statusId
      })
        .then(() => {
          window.notify.success("Job status updated successfully!");
          EventBus.$emit("refresh-job");
        })
        .catch((e) => {
          window.notify.error(e.message);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
:deep(input.ss-input-field) {
  border: 1px solid var(--medium-color);
}
</style>
